import React from 'react';
import Form from "react-bootstrap/Form";
import {Typeahead} from "react-bootstrap-typeahead";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
import '../_static/ComboBox.css'

function ComboBox(props) {
    const typeaheadRef = React.useRef(null);

    const {disable} = React.useContext(ChangeCheckContext)
    const { onChange, getStyle } = useChangeCheck(props.onChange);
    const [selected, setSelected] = React.useState(props.value)
    // Changed value is used to avoid updates, when nothing is selected, but input is blurred i.e. due to user clicking
    // outside of the input
    const [changedValue, setChangedValue] = React.useState(false)

    React.useEffect(() => {
        // So that we can control value both internally and externally
        // reset prop is necessary if value did not change
        setSelected(props.value)
    }, [props.value, props.reset]) // eslint-disable-line react-hooks/exhaustive-deps

    function handleChange(selection) {
        setChangedValue(true)
        if (selection[0] !== undefined) {
            setSelected(selection[0])
            if (typeaheadRef.current) {
                typeaheadRef.current.blur();
            }
        }
    }

    function handleInputChange(value) {
        const newValue = value
        setSelected(newValue)
    }

    function handleBlur(event) {
        if (selected && changedValue) {
            setChangedValue(false)
            onChange({target: {name: props.name, value: selected}})
            if (props.stateResetOnChange){
                setSelected("")
            }
        }
    }



    return (
        <>
            <Form.Group>
                {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
                <div>
                    <Typeahead
                        className={'custom-typeahead'}
                        disabled={disable}
                        positionFixed={true}
                        id="basic-typeahead-single"
                        labelKey={props.optionDisplay}
                        ref={typeaheadRef}
                        onChange={(selection) => handleChange(selection)}
                        onBlur={handleBlur}
                        options={props.options}
                        placeholder={"vyber"}
                        selected={[selected]} //since selected is expecting array, we need to turn value into array
                        onInputChange={handleInputChange}
                        style={getStyle()}
                    />
                </div>
            </Form.Group>
        </>
    );
};

export default ComboBox;